import { TurboLiveEntity } from './index';

export declare type PushData = TurboLiveEntity | Delta | { id: string };

export interface PushEnvelope {
    paths: string[];
    payload: PushPayload;
}

export enum PushEntity {
    BET = 'B',
    MARKET = 'MK',
    MARKET_CATEGORY = 'MKC',
    MATCH = 'M',
    TOURNAMENT = 'T',
    SPORT = 'S',
    MBM = 'MBM'
}

export enum PushEvent {
    CREATED = 'C',
    UPDATED = 'U',
    DELETED = 'D'
}

export interface Delta {
    id: string;
    diff: any;
}

export interface PushPayload {
    t: PushEntity;
    e: PushEvent;
    d: PushData;
    v?: number;
    vid?: string;
}
